import { transformRovoChatDeepLink } from '../url-transformer';

const DEEP_LINK_TARGET_PARAM = 'deepLinkTarget';

export const isDeepLink = (urlString: string): boolean => {
	const url = new URL(urlString);
	const paramValue = url.searchParams.get(DEEP_LINK_TARGET_PARAM);
	return paramValue !== null && paramValue !== '';
};

/**
 * Checks if the provided URL should be opened by the current product
 * by verifying the deepLinkTarget parameter matches the productKey
 * and the URL origin matches the current window origin.
 */
export const isDeepLinkForCurrentApp = (urlString: string, productKey: string): boolean => {
	const url = new URL(urlString);
	return (
		url.searchParams.get(DEEP_LINK_TARGET_PARAM) === productKey &&
		url.origin === window.location.origin
	);
};

export const shouldHandleDeepLink = ({
	url,
	onDeepLinkClick,
}: {
	url: string;
	onDeepLinkClick?: (url: string) => void;
}): boolean => {
	return !!url && isDeepLink(url) && !!onDeepLinkClick;
};

export const handleDeepLink = ({
	url,
	productKey,
	onDeepLinkClick,
	conversationId,
}: {
	url: string;
	productKey: string;
	onDeepLinkClick?: (url: string) => void;
	conversationId?: string;
}): void => {
	if (onDeepLinkClick && isDeepLinkForCurrentApp(url, productKey)) {
		onDeepLinkClick(url);
		return;
	}

	// If the deep link is not for the current product, or the product did not set up a callback
	// open the link in new tab with Rovo opened
	const transformedUrl = transformRovoChatDeepLink(url, conversationId);
	window.open(transformedUrl.toString(), '_blank', 'noopener, noreferrer');
};

/*
 * Callback for editor Link component to determine link target.
 * Returns '_blank' if the link should render as an External link.
 */
export const handleOnSetLinkTarget = (url: string, productKey: string): '_blank' | undefined => {
	if (isDeepLink(url) && !isDeepLinkForCurrentApp(url, productKey)) {
		return '_blank';
	}
	return undefined;
};
